<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Home Page Video Management <span class="badge">{{homePageVideoData ? homePageVideoData.length : 0 }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn"> <span><img src="../../../assets/images/backend-image/header/exportIcon.svg"
							alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewHomePageVideo()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add Video</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadHomePageVideosList(lastTableLazyLoadEvent)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>

			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class="expandable" #dt [value]="homePageVideoData" [paginator]="true" [rows]="10"
						[lazy]="true" scrollHeight="auto" scrollDirection="both"
						(onLazyLoad)="loadHomePageVideosList($event)" [totalRecords]="totalHomePageVideoDataCount"
						[loading]="loading" [rowsPerPageOptions]="paginationOption"
						styleClass="p-datatable-gridlines p-datatable-striped w-100">
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="title" class="col-180 titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Title
										<p-sortIcon field="title"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="thumbNailImage" class="col-180 viewBtnTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Thumbnail Image
									</div>
								</th>
								<th pSortableColumn="youtubechannelurl" class="col-180 YoutubeTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Youtube Url
										<p-sortIcon field="youtubechannelurl"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="col-150 p-d-flex p-jc-between p-ai-center ">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>

									<th pSortableColumn="sequence" class="col-180 sequenceTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Sequence
										<p-sortIcon field="sequence"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at" class="  createdDateTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Date of Creation
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="createdBy" class="col-180 CreatedByTD"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Created By
										<p-sortIcon field="createdBy"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at" class="col-180 updatedTD"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Modified On
										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updatedBy" class="col-180 ModifiedbyTD"
									[ngClass]="hide ? 'hide-column' : 'show-column'">
									<div class="p-d-flex p-jc-between p-ai-center">
										Modified By
										<p-sortIcon field="updatedBy"></p-sortIcon>
									</div>
								</th>
								<th class="col-180 actionTD p-frozen-column">Action</th>
							</tr>
							<tr>
								<th [ngSwitch]="title">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'title', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['title'] ? dt.filters['title'].value : ''" />
								</th>
								<th>

								</th>
								<th [ngSwitch]="youtubechannelurl">
								</th>

								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown #pDropDownId [options]="statuses"
										(onChange)="dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Status" >
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>

									<th [ngSwitch]="sequence">
								</th>



								<th [ngSwitch]="created_at" class="createdDateTD">
								</th>
								<th [ngSwitch]="createdBy" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'createdBy', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['createdBy'] ? dt.filters['createdBy'].value : ''" />
								</th>
								<th [ngSwitch]="updated_at" [ngClass]="hide ? 'hide-column' : 'show-column'">
								</th>
								<th [ngSwitch]="updatedBy" [ngClass]="hide ? 'hide-column' : 'show-column'">
									<input pInputText type="text"
										(keyup.enter)="dt.filter($event.target.value, 'updatedBy', 'contains')"
										style="width: 100%;"
										[value]="dt.filters['updatedBy'] ? dt.filters['updatedBy'].value : ''" />
								</th>

								<th class="p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-homePageVideoData let-rowIndex="rowIndex">
							<tr>
								<td class="col-180 titleTD">
									{{homePageVideoData.title}}
								</td>

								<td class="viewBtnTd">
									<p-galleria [effect]="slide" [(value)]="thumbnailImageArray"
										[(visible)]="showThumbNailImage" [responsiveOptions]="responsiveOptions"
										[containerStyle]="{'max-width': '850px'}" [circular]="true" [fullScreen]="true"
										[showThumbnails]="false" [baseZIndex]="100000">
										<ng-template pTemplate="item" let-item>
											<img [src]="item.image_src"
												style="width:100%; height:100%; display: block;" />
										</ng-template>
									</p-galleria>
									<button pButton *ngIf="homePageVideoData.thumbNailImage.length > 0" type="button"
										icon="pi pi-eye" label="View"
										(click)="onShowThumbNailImage(homePageVideoData.thumbNailImage)"></button>
								</td>

								<td class="col-200 YoutubeTD">
									<span class="textOverFlow1">{{homePageVideoData.youtubechannelurl}}</span>
								</td>

								
								<td class="col-150 statusTD">
									<div class="swichTable">
										<p-inputSwitch [(ngModel)]="homePageVideoData.status"
										(onChange)="changeStatus(homePageVideoData)">
										
									</p-inputSwitch>
									<div class="label activeText" *ngIf="homePageVideoData.status">
										Active
									</div>
									<div class="label InActiveText" *ngIf="!homePageVideoData.status">
										Inactive
									</div>
								</div>
							</td>
							
							<td class="col-150 sequenceTD">
							<span class="textOverFlow1">{{homePageVideoData.sequence}}</span>
						</td>

						
								<td class="col-180 createdDateTD">
									{{homePageVideoData.created_at | date: 'dd/MM/yyyy'}}
								</td>

								<td class="col-180 CreatedByTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{homePageVideoData.createdBy}}
								</td>

								<td class="col-180 updatedTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{homePageVideoData.updated_at | date: 'dd/MM/yyyy'}}
								</td>
								<td class="col-180 ModifiedbyTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
									{{homePageVideoData.updatedBy}}
								</td>

								<!-- <td class="col-180 actionTD"><span class="p-column-title">Action</span>
							<button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-4"
								(click)="onEditHomePageVideoData(homePageVideoData)"></button>
							<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning p-mr-4" (click)="onDelete(homePageVideoData)"></button>
						</td> -->
								<td class="text-nowrap p-element p-frozen-column" pfrozencolumn="" alignfrozen="right"
									style="width: 200px; right: 0px;">
									<ul class="actionList">
										<li>
											<button (click)="onEditHomePageVideoData(homePageVideoData) "
												class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="onDelete(homePageVideoData)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
									</ul>
									<!-- <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-success p-mr-2" (click)="viewseller(seller.id)"></button> -->

								</td>
							</tr>
						</ng-template>
						<!-- <ng-template pTemplate="summary">
							<div class="p-d-flex p-ai-center p-jc-between">
								In total there are {{homePageVideoData ? homePageVideoData.length : 0 }} HomePage
								Videos.
							</div>
						</ng-template> -->
					</p-table>
				</div>
			</div>


		</div>
	</div>
</div>

<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>